function RafleItem(endingSquareNum, capturedSquareNum) {
    this.capturedSquareNum = capturedSquareNum ? capturedSquareNum : null;
    this.endingSquareNum = endingSquareNum;
}

RafleItem.prototype.getNumber = function() {
    return this.endingSquareNum;
};

RafleItem.prototype.toString = function() {
    //return JSON.stringify(this);
    return "" + this.endingSquareNum;
};

module.exports = RafleItem;



//////////////////
// WEBPACK FOOTER
// ./~/draughts-reader-core/src/brain/RafleItem.js
// module id = bAB1
// module chunks = 4